import ChargePricingListView from '../../components/ChargePricingListView';

ChargePricingListScreen.propTypes = {};

function ChargePricingListScreen(props) {
  return (
    <div className="container-fluid px-4 my-4">
      <ChargePricingListView />
    </div>
  );
}

export default ChargePricingListScreen;
